var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-611 -228)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.048,15.844H34.33V36.97H29.048Zm2.641,32.349a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,31.689,48.194Z",
  transform: "translate(611.612 228)",
  fill: "#09f"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(611 228)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "rgba(255,255,255,0)",
  stroke: "#09f",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 30.5,
  fill: "none"
})))))));
export default SvgIconExclamation;